import React from 'react'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import { GraphQLFormProvider } from '@mymeerkat/react-form-helper'
import { renderInput, BuildLayout, renderDisplay } from '../generic';

const config = {
  name: 'group',
  fields: {
    name: {
      type: 'name',
      label: 'Group Name',
      validate: (value) => {
        if (!value) {
          return 'Group Name is required'
        }
      }
    },
    postalCode: {
      type: 'text',
      label: 'Postal Code',
    },
  },
  query: gql`
    query GroupData($id: String!) {
      group(id: $id) {
        id
        name
        postalCode
      }
    }`,
  updateMutation: gql`
    mutation UpdateGroup($input: UpdateGroupInput!, $id: String!) {
      updateGroup(id: $id, input: $input) {
        id
        name
        postalCode
      }
    }`,
}

const FormLayout = (props) => {
  const { cancel, formName } = props;
  return (<BuildLayout formName={formName} fieldNames={Object.keys(config.fields)} fieldConfig={config.fields} direction='column' spacing={2} align='center' justify='center' cancel={cancel} />);
}

let EditGroup = (props) => {
  const { cancel, id } = props;

  return (
    <div>
      <GraphQLFormProvider
        mode="edit"
        id={id}
        {...config}
        afterSubmit={({ data }) => { cancel() }}
        renderDisplay={renderDisplay}
        renderInput={renderInput}
        InputFormLayout={(props) => <FormLayout {...props} formName={config.name} cancel={cancel} />}
        DisplayFormLayout={FormLayout}
        initialValuesFromData={(data) => {
          const { ...rest } = data.group || {}
          return ({ ...rest })
        }}
        mapInputVariables={(props) => {
          const { name, postalCode } = props;
          return ({ input: { name, postalCode } })
        }}
        keepInitialValues
      />
    </div>
  )
}
EditGroup = withApollo(EditGroup);
export default EditGroup
